// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7395933b","395":"1034ed40","496":"67a4f8a4","675":"0b99f5fe","678":"1153f481","822":"d54d726e","882":"41002624","918":"29c2532c"}[chunkId] + ".chunk.js";
};